import { Component, OnInit } from '@angular/core';
import { SpinnerServices } from 'src/app/core/services/spinner.service';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit {

  isLoading$;
  
  logo: string | null = this.normalizeStoredLogo(localStorage.getItem('X-AVATAR-CNT05LOG'));
  safeBackground: SafeStyle | string = `url('assets/images/avatar-ia-v1.png')`;

  constructor(
    private spinnerSvc: SpinnerServices,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.isLoading$ = this.spinnerSvc.isLoading$;
    this.updateSafeBackground();
  }

  private normalizeStoredLogo(raw: string | null): string | null {
    if (!raw) return null;
    let v = String(raw).trim();

    if ((v.startsWith('"') && v.endsWith('"')) || (v.startsWith("'") && v.endsWith("'"))) {
      v = v.slice(1, -1).trim();
    }

    const comma = v.indexOf(',');
    if (v.startsWith('data:') && comma > -1) {
      v = v.slice(comma + 1);
    }

    v = v.replace(/\s+/g, '');

    if (!v || v.toLowerCase() === 'null' || v.toLowerCase() === 'undefined') return null;
    return v;
  }

  private updateSafeBackground(): void {
    if(localStorage.getItem('CLITUT') == 'cuc'){
      try {
        if (this.logo) {
          const css = `url("data:image/png;base64,${this.logo}")`;
          this.safeBackground = this.sanitizer.bypassSecurityTrustStyle(css);
        } else {
          this.safeBackground = `url('assets/images/avatar-ia-v1.png')`;
        }
      } catch (e) {
        this.safeBackground = `url('assets/images/avatar-ia-v1.png')`;
      }
    }else{
      this.safeBackground = `url('assets/images/avatar-ia-v1.png')`;
    }
  }

}